export default __webpack_public_path__ + "static/media/eightypercent.498d1e85.gif";